import React from "react";

export function MenuSpacing({ pixels }) {
  return <div style={{ paddingTop: pixels }} />;
}
